import { render } from "./ModalPay.vue?vue&type=template&id=7ee6be58"
import script from "./ModalPay.vue?vue&type=script&lang=js"
export * from "./ModalPay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__